import { useMemo } from 'react';
import { useField } from 'formik';
import { Space } from 'antd';
import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import FormSelect, { SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { getDeclarationNameLabels } from 'views/invoice-upload/utils';
import { useBrokerUploadContext } from '../BrokerUploadProvider';
import { BrokerUploadSteps } from '../types';

const stepKey = BrokerUploadSteps.FORM_TYPE;
const fieldName = 'formType.formType';

const FormTypeStep = () => {
    const [field, meta, helpers] = useField(fieldName);
    const { isActive, isComplete, isIdle, resetStep, stepsConfig } = useMultiStepFormContext<any>();
    const { country, type } = useBrokerUploadContext();

    const isPreSelected = stepsConfig.find((s) => s.key === stepKey)?.disabled ?? false;

    const selectOptions: SelectOption[] = getDeclarationNameLabels(country, type).map(({ key, value }) => ({
        id: key,
        value,
    }));

    const readonlyValue = useMemo(
        () => selectOptions.find((opt) => opt.id === field.value)?.value ?? field.value,
        [field.value, selectOptions]
    );

    const sectionTitle = 'Form';

    if (isIdle(stepKey)) {
        return <FormSectionHeader title={sectionTitle} icon={<FileTextIconOutlined />} />;
    }

    if (isPreSelected) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormSectionHeader title={sectionTitle} icon={<FileTextIconOutlined />} />
                <ReadonlyFormItem disabled={true} value={readonlyValue} />
            </div>
        );
    }

    if (isComplete(stepKey)) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormSectionHeader title={sectionTitle} icon={<FileTextIconOutlined />} />
                <ReadonlyFormItem
                    disabled={false}
                    value={readonlyValue}
                    onReset={() => resetStep(stepKey, 'formType')}
                />
            </div>
        );
    }

    if (isActive(stepKey)) {
        return (
            <Space style={{ width: '100%' }} direction="vertical">
                <FormSectionHeader title={sectionTitle} icon={<FileTextIconOutlined />} />
                <FormSelect
                    placeholder="Select Form"
                    hideKeys
                    style={{ minWidth: '100%' }}
                    selectOptions={selectOptions}
                    fieldHelper={helpers}
                    fieldProps={field}
                    fieldMeta={meta}
                />
            </Space>
        );
    }

    return null;
};

export default FormTypeStep;
